import { render, staticRenderFns } from "./Deep.vue?vue&type=template&id=8ca01c6c&scoped=true"
import script from "./Deep.vue?vue&type=script&lang=js"
export * from "./Deep.vue?vue&type=script&lang=js"
import style0 from "./Deep.vue?vue&type=style&index=0&id=8ca01c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca01c6c",
  null
  
)

export default component.exports